function walk(x, y, direction, path) {
	return direction == 'v' ?
		{x, y: y + path} :
		{x: x + path, y} ;
}

function opp_dir(dir) {
	return dir == 'h' ? 'v' : 'h';
}

function min(a,b) {
	return a*1 < b*1 ? a : b;
}

function max(a,b) {
	return a*1 > b*1 ? a : b;
}

class Crossword {
	/*
	constructor(...words) {
		this.field = {};
		this.position = {};
		this.X_intersection = 0;
		this.T_intersection = 0;
		this.L_intersection = 0;
		this.corners_touching = 0;
		this.multiple_intersections = {};
		this.words_with_the_same_beginning = [];

		if (words.length == 0) return;

		words = words.sort( (a,b) => b.length - a.length );
		let res = [this];

		let later = [];
		let added_something = false;

		for (let i=0; i < words.length; i++) {
			console.log('Adding word: ', words[i]);
			let new_gen = [];

			let continu = [];

			while (1) {
				let child_added = false;
				for (let n=0; n < res.length; n++) {
					if (continu[n] == 'done') continue;
					let t = res[n].add_word_ltd(words[i], continu[n]);
					if (t.res) if (t.res.length > 0) {
						new_gen = new_gen.concat(t.res);
						child_added = true;
					}
					
					continu[n] = t.continu;
				}
				if (!child_added) break;
				if (new_gen.length > 1000) {
					if (i < words.length - 1) break;
				}
			}
			console.log('NEW_GEN READY : ',new_gen);
				


			if (new_gen.length == 0) {
				later.push(words[i]);
			}
			else {
				res = new_gen;
				added_something = true;
			}

			if (i == words.length - 1 && later.length > 0 && added_something) {
				console.log('Starting a new cycle because I still gotta add: ', later);
				added_something = false;
				words = words.concat(later);
				later = [];
			}
		}
		return res;
	}*/

	
	//Find and delete twins
	//
	/*
	for (let k=0; k < new_gen.length; k++) {
		for (let g=k+1; g < new_gen.length; g++) {
			if (new_gen[k].is_the_same(new_gen[g])) {
				console.log('OMG TWINS!!!');
				new_gen[k].is_a_twin = true;
			}
		}
	}
	new_gen = new_gen.filter(x => !x.is_a_twin);
	*/

	constructor(...words) {
		this.field = {};
		this.position = {};
		this.X_intersection = 0;
		this.T_intersection = 0;
		this.L_intersection = 0;
		this.corners_touching = 0;
		this.multiple_intersections = {};
		this.words_with_the_same_beginning = [];

		if (words.length == 0) return this;

		let all_cws = [];
		this.add_word_to_position(words[0], 0, 0, 'h');

		this.add_the_rest(words.slice(1), all_cws, 10);
		//this.add_the_rest(words, all_cws, 1);
		return all_cws;
	}

	get(x,y) {
		if (!this.field[x]) return undefined;
		return this.field[x][y];
	}

	set(x,y,value) {
		if (this.field[x] == undefined) this.field[x] = {};
		this.field[x][y] = value;
	}

	copy () {
		return Object.assign(new Crossword(), JSON.parse(JSON.stringify(this)) );
	}

	is_empty(position) {
		if (this.get(position.x, position.y)) return false;
		return true;
	}

	add_word_to_position(word, x, y, direction) {
		//console.log("TRYING TO ADD: ", word);
		let new_table = this.copy();
		//console.log("New TABLE: ", new_table);
		let mp = {x, y, direction};

		let before_first = walk(x, y, direction, -1);
		let after_last = walk(x, y, direction, word.length);
		let last = walk(x, y, direction, word.length - 1);

		if (!new_table.is_empty(before_first) || !new_table.is_empty(after_last) ) {
			//console.log("BEFORE_FIRST OR AFTER_LAST IS OCCUPIED");
			return false;
		}

		//Checking for corners touching
		for (let n of [-1,1]) {
			for (let s of [before_first, after_last]) {
				let corner = walk(s.x, s.y, opp_dir(direction), n);

				let side = (s == before_first) ?
					walk(x, y, opp_dir(direction), n) :
					walk(last.x, last.y, opp_dir(direction), n); 

				if (new_table.is_empty(side) && !new_table.is_empty(corner)) {
					new_table.corners_touching++;
				}
			}
		}

		let intersections = 0;
		for (let i=0; i < word.length; i++) {

			let np = walk(x,y,direction, i);
			if (!new_table.is_empty(np)) {
				if (new_table.get(np.x,np.y) != word[i]) {
					//console.log('RUN INTO!!!!!', new_table.get(np.x,np.y), word[i]);
					return false;
				}
				intersections++;
			} else {
				for (let n of [-1,1]) {
					let side = walk(np.x, np.y, opp_dir(direction), n);
					if ( !new_table.is_empty(side) ) return false;
				}
			}

			new_table.set(np.x, np.y, word[i]);
		}

		this.field = new_table.field;
		this.position[word] = mp;
		this.corners_touching = new_table.corners_touching;

		if (intersections > 1) {
			if (this.multiple_intersections[intersections])
				this.multiple_intersections[intersections]++;
			else this.multiple_intersections[intersections] = 1;
		}

		return true;
	}

	connect(word1, letter1, word2, letter2) {
		let new_dir = opp_dir(this.position[word1].direction);
		let {x,y,direction} = this.position[word1];
		let intersec = walk(x,y,direction, letter1);
		let np = walk(intersec.x, intersec.y, new_dir, -letter2);
		return this.add_word_to_position(word2, np.x, np.y, new_dir);
	}

	add_word_ltd(new_word, continu) {
		//console.log('Continuing from: ',continu);
		//if (continu == 'done') return {res: [], continu: 'done'};
		if (!continu) continu = {n:0,i:0,k:0};
		let res = [];
		if (Object.keys(this.position).length === 0 && this.position.constructor === Object) {
			let c = this.copy();
			c.add_word_to_position(new_word, 0, 0, 'h');
			return {res: [c], continu: 'done' };
		}
		let words = Object.keys(this.position);
		for (let n = continu.n ; n < words.length; n++) {
			let w = words[n];
			for (let i = 0; i < w.length; i++) {
				//console.log('Checking letter of table word: ', w[i]);
				for (let k = 0; k < new_word.length; k++) {
					if (continu) {
						({i,k,n} = continu);
						continu = null;
					}
					//console.log('Checking letter of new_word: ', new_word[k]);
					if (w[i] == new_word[k]) {
						let c = this.copy();
						//console.log('INTESECTION FOUND: ',w,new_word,i,k);
						
						if ((i == 0 || i == w.length - 1) && (k == 0 || k == new_word.length - 1)) {
							c.L_intersection++;
							if (i == 0 && k == 0) {
								c.words_with_the_same_beginning.push(w, new_word);
							}
						}
						else if (i != 0 && i != w.length - 1
							&& k != 0 && k != new_word.length - 1)
							c.X_intersection++;
						else c.T_intersection++;
						

						if (c.connect(w, i, new_word, k)) {
							res.push(c);
							k++;
							return {res, continu: {n,i,k} };
						}
					}
				}
			}
		}
		return {res: [], continu: 'done'};
	}

	add_word(new_word) {
		/*
		if (Object.keys(this.position).length === 0 && this.position.constructor === Object) {
			let c = this.copy();
			c.add_word_to_position(new_word, 0, 0, 'h');
			return [c];
		}*/

		let res = [];

		for (let w in this.position) {
			for (let i = 0; i < w.length; i++) {
				for (let k = 0; k < new_word.length; k++) {
					if (w[i] == new_word[k]) {
						let c = this.copy();

						if (c.connect(w, i, new_word, k)) {
							if ((i == 0 || i == w.length - 1) && (k == 0 || k == new_word.length - 1)) {
								c.L_intersection++;
								if (i == 0 && k == 0) {
									c.words_with_the_same_beginning.push(w, new_word);
								}
							}
							else if (i != 0 && i != w.length - 1
								&& k != 0 && k != new_word.length - 1)
								c.X_intersection++;
							else c.T_intersection++;
							
							res.push(c);
						}
					}
				}
			}
		}
		return res;
	}

	add_the_rest(rest, all, limit) {
		//console.log({already_have: all, rest});

		for (let n of rest) {
			let f = this.add_word(n);
			if (f.length == 0) continue;

			let new_rest = rest.filter(x => x != n);

			if (new_rest.length > 0) {
				for (let c of f) {
					c.add_the_rest(new_rest, all, limit);
					if (all.length >= limit) return;
				}
			}
			else {
				//console.log("Adding the last word: ", f);
				all.push.apply(all, f);
				if (all.length >= limit) return;
			}
		}
	}

	is_the_same(c) {
		let w = Object.keys(this.position)[0];
		if (!c.position[w]) return false;
		let dx = this.position[w].x - c.position[w].x;
		let dy = this.position[w].y - c.position[w].y;

		for (let word in this.position) {
			let p1 = this.position[word];
			let p2 = c.position[word];
			if (!p2) return false;
			if (p1.x - p2.x != dx || p1.y - p2.y != dy || p1.direction != p2.direction)
				return false;
		}
		return true;
	}

	fix_position() {
		let min_x = 0, max_x = 0, min_y = 0, max_y = 0;

		for (let x in this.field) {
			min_x = min(min_x, x);
			max_x = max(max_x, x);
			for (let y in this.field[x]) {
				min_y = min(min_y, y);
				max_y = max(max_y, y);
			}
		}

		this.width = max_x - min_x + 1;
		this.height = max_y - min_y + 1;

		for (let word in this.position) {
			this.position[word].x -= min_x;
			this.position[word].y -= min_y;
		}
		this.fixed = true;
	}

	calc_squares() {
		if (!this.fixed) this.fix_position();

		let res = {};

		for (let word in this.position) {
			let letters = [];
			let mp = this.position[word];

			for (let i=0; i < word.length; i++) {
				let np = walk(mp.x, mp.y, mp.direction, i);
				//this.squares.push({x: np.x, y: np.y, letter: word[i]});
				letters.push({style: `left: ${np.x*30}px; top: ${np.y*30}px`}); //, letter: word[i]
			}
			res[word] = letters;
		}

		return res;
	}
}

export default Crossword;